export default [
  {
    "name": "Rebuild Table of Contents",
    "description": "The Digital Hub will attempt to link the existing TOC to corresponding chapter heads and similar elements. If enabled, the Hub will delete the existing TOC and will replace it with one generated automatically from chapter heads and similar elements.",
    "slug": "toc_rebuild",
    "enabled": false,
    "conversions": [
      "docx2epub3",
      "docx2scml",
      "indd2epub3",
      "indd2scml",
      "sam2epub3",
      "sam2scml",
      "scml2scml"
    ]
  },
  {
    "name": "Enhanced Bible IDTT Output",
    "description": "If enabled, the Hub will apply alt styles to paragraph-level elements containing verse numbers based on whether the number has one, two, or three digits; add tabs after every verse number; and place a thin space between all adjacent quotation marks.",
    "slug": "bible",
    "enabled": false,
    "conversions": [
      "docx2idtt",
      "indd2idtt",
      "sam2idtt",
      "scml2idtt"
    ]
  },
  {
    "name": "Remove Cross-References",
    "description": "If enabled, the Hub will remove all cross-reference styles. The content of the cross-reference, however, will not change. Cross-reference styles are very helpful in digital publications but might not be useful in a document intended for editing.",
    "slug": "remove_xrefs",
    "enabled": false,
    "conversions": [
      "sam2docx",
      "scml2docx",
      "indd2docx"
    ]
  },
  {
    "name": "Backlink Chapter Heads to TOC",
    "description": "The Digital Hub will link the first chapter-level head in each chapter (typically the chapter number or chapter title) back to the table of contents.",
    "slug": "backlink_toc",
    "enabled": true,
    "conversions": [
      "docx2epub3",
      "indd2epub3",
      "sam2epub3",
      "scml2epub3"
    ]
  },
  {
    "name": "Reciprocally Link Notes",
    "description": "The Digital Hub will link each footnote or endnote (fn or en) back to an in-text marker (fnref or enref) based on the order in which each appears.",
    "slug": "backlink_notes",
    "enabled": true,
    "conversions": [
      "docx2epub3",
      "indd2epub3",
      "sam2epub3",
      "scml2epub3"
    ]
  },
  {
    "name": "Small Caps Backward Compatibility",
    "description": "The Hub will remove the small caps style from capital letters and will capitalize and keep the style for lowercase letters. Setting the font size at 80% or less for small caps in the project CSS will enable the text to render properly in old and new e-readers.",
    "slug": "small_caps_break",
    "enabled": true,
    "conversions": [
      "docx2epub3",
      "indd2epub3",
      "sam2epub3",
      "scml2epub3"
    ]
  },
  {
    "name": "Embed Footnotes",
    "description": "If the quantity of footnote markers (fnref) matches the quantity of footnote numbers (fnnum), the Hub will embed the footnotes. If the counts do not match, it will not embed the footnotes.",
    "slug": "embed_notes",
    "enabled": true,
    "conversions": [
      "docx2idtt",
      "indd2idtt",
      "sam2idtt",
      "scml2idtt"
    ]
  },
  {
    "name": "Standardize Ellipses",
    "description": "The Hub will format all ellipses as periods separated by nonbreaking spaces and adjust any surrounding space to conform to CMS and general conventions. This includes closing up the space when adjacent to quotation marks, parentheses, or em dashes.",
    "slug": "standardize_ellipses",
    "enabled": true,
    "conversions": [
      "docx2idtt",
      "indd2idtt",
      "sam2idtt",
      "scml2idtt",
      "scml2pdf"
    ]
  },
  {
    "name": "Add Note Tabs",
    "description": "The Hub will add a tab at the beginning of each note (fn or en) that is not embedded and a tab following its number or marker (fnnum or ennum), if it doesn’t already have one in those spots. This will make it easier to align note numbers or markers in the typeset.",
    "slug": "add_note_tabs",
    "enabled": true,
    "conversions": [
      "docx2idtt",
      "indd2idtt",
      "sam2idtt",
      "scml2idtt"
    ]
  },
  {
    "name": "Add List Tabs",
    "description": "The Digital Hub will add a tab at the beginning of each numbered list item (nl), if it doesn’t already have one. Having tabs will make it easier to decimal align or right align the list numbers in the typeset.",
    "slug": "add_list_tabs",
    "enabled": true,
    "conversions": [
      "docx2idtt",
      "indd2idtt",
      "sam2idtt",
      "scml2idtt"
    ]
  },
  {
    "name": "Convert Notes",
    "description": "The Digital Hub will remove footnotes and endnotes embedded in a Word document and will place them at the end of the resulting file. Note markers other than numbers, letters, or Roman numerals (asterisk, dagger, etc.) will be replaced with numbers.",
    "slug": "strip_notes",
    "enabled": true,
    "conversions": [
      "docx2epub3",
      "docx2idtt",
      "docx2scml",
      "docx2sam"
    ]
  },
  {
    "name": "Scribe Language Styles",
    "description": "If enabled, the Hub will identify words with characters outside the basic ASCII range, use Chromium Compact Language Detector to guess the language, and apply a unique character style with a “lang” attribute (including a two-letter ISO 639-1 code).",
    "slug": "lang_finder",
    "enabled": false,
    "conversions": [
      "docx2epub3",
      "docx2idtt",
      "docx2scml",
      "docx2sam",
      "indd2epub3",
      "indd2scml",
      "sam2epub3",
      "sam2scml",
      "scml2scml"
    ]
  },
  {
    "name": "Articulate Spacing Distinctions",
    "description": "If enabled, the Hub will apply the style distinctions (first, last, and stand-alone variations) necessary to achieve proper spacing, for example, extra space above or below a paragraph (or both above and below), as appropriate to the context.",
    "slug": "articulate",
    "enabled": false,
    "conversions": [
      "docx2epub3",
      "docx2idtt",
      "docx2scml",
      "indd2epub3",
      "indd2idtt",
      "indd2scml",
      "sam2epub3",
      "sam2idtt",
      "sam2scml"
    ]
  },
  {
    "name": "Scribe Diacritics and Fractions",
    "description": "If enabled, the Hub will identify characters with diacritics and fractions and apply a “dcrit” or “frac” character style.",
    "slug": "mark_dcrits",
    "enabled": false,
    "conversions": [
      "docx2idtt",
      "indd2idtt",
      "sam2idtt",
      "scml2idtt"
    ]
  },
  {
    "name": "Nest E-Reader Table of Contents Items",
    "description": "If enabled, the Hub will nest navigation points for the ePub (in the toc.ncx or the toc.xhtml) based on their hierarchy.",
    "slug": "nested_toc",
    "enabled": true,
    "conversions": [
      "docx2epub3",
      "indd2epub3",
      "sam2epub3",
      "scml2epub3"
    ]
  },
  {
    "name": "Print-Specific Head Styles for Front and Back Matter",
    "description": "If enabled, in IDTT output the Hub will add “-altfm” to the names of body heads in the front matter section and “-altbm” to the names of heads in the back matter section.",
    "slug": "fm_bm_alts",
    "enabled": false,
    "conversions": [
      "docx2idtt",
      "indd2idtt",
      "sam2idtt",
      "scml2idtt"
    ]
  },
  {
    "name": "Remove Structure Indicators",
    "description": "If enabled, the Hub will not include structure indicators for block-level elements in *.docx output.",
    "slug": "remove_structs",
    "enabled": false,
    "conversions": [
      "sam2docx",
      "scml2docx",
      "indd2docx"
    ]
  },
  {
    "name": "Remove Page Indicators",
    "description": "If enabled, the Hub will not include page indicators in *.docx output.",
    "slug": "remove_pages",
    "enabled": true,
    "conversions": [
      "sam2docx",
      "scml2docx",
      "indd2docx"
    ]
  },
  {
    "name": "Remove Typesetter Tab Patterns",
    "description": "If enabled, the Hub will adjust known tab patterns used for typeset purposes to spacing appropriate for digital formats.",
    "slug": "adjust_tabs",
    "enabled": true,
    "conversions": [
      "indd2epub3",
      "indd2idtt",
      "indd2scml",
      "indd2sam",
      "indd2docx"
    ]
  },
  {
    "name": "Remove Tab Patterns",
    "description": "If enabled, the Hub will adjust known tab patterns used in manuscripts to spacing appropriate for digital formats.",
    "slug": "d2s_adjust_tabs",
    "enabled": false,
    "conversions": [
      "docx2epub3",
      "docx2idtt",
      "docx2scml",
      "docx2sam"
    ]
  },
  {
    "name": "Unnest Note Heads",
    "description": "If enabled, when the Hub converts footnotes and endnotes embedded in an MS Word document it will move section heads out of the footnotes or endnotes and into the regular text flow.",
    "slug": "unnest_note_heads",
    "enabled": true,
    "conversions": [
      "docx2epub3",
      "docx2idtt",
      "docx2scml",
      "docx2sam"
    ]
  },
  {
    "name": "Place Footnotes after Section Breaks",
    "description": "If enabled, when the Hub converts footnotes embedded in an MS Word document it will move the footnotes to the end of the nearest section in the document instead of the end of the file.",
    "slug": "strip_fn_by_sect",
    "enabled": false,
    "conversions": [
      "docx2epub3",
      "docx2idtt",
      "docx2scml",
      "docx2sam"
    ]
  },
  {
    "name": "Place Endnotes after Section Breaks",
    "description": "If enabled, when the Hub converts endnotes embedded in an MS Word document it will move the endnotes to the end of the nearest section in the document instead of the end of the file.",
    "slug": "strip_en_by_sect",
    "enabled": false,
    "conversions": [
      "docx2epub3",
      "docx2idtt",
      "docx2scml",
      "docx2sam"
    ]
  },
  {
    "name": "Place Footnotes at End of Chapter",
    "description": "If enabled, the Hub will move the footnotes to the end of the chapter in the document where the corresponding footnote reference occurs instead of the end of the file.",
    "slug": "place_fn_by_chapter",
    "enabled": false,
    "conversions": [
      "sam2scml",
      "sam2epub3",
      "sam2html",
      "scml2scml"
    ]
  },
  {
    "name": "Articulate Spacing Distinctions for MS Word",
    "description": "If enabled, the Hub will apply the style distinctions (first, last, and stand-alone variations) necessary to achieve proper spacing, for example, extra space above or below a paragraph (or both above and below), as appropriate to the context.",
    "slug": "articulate_docx",
    "enabled": true,
    "conversions": [
      "docx2docx"
    ]
  },
  {
    "name": "Apply ScML Template Definitions",
    "description": "If enabled, the Hub will clear any locally applied paragraph formatting in the MS Word Refiner. This allows the formatting associated with the paragraph's ScML style in the template to display correctly.",
    "slug": "clear_para_rend",
    "enabled": true,
    "conversions": [
      "docx2docx"
    ]
  },
  {
    "name": "Convert Notes in MS Word",
    "description": "The Digital Hub will remove footnotes and endnotes embedded in a Word document and will place them at the end of the refined MS Word document. Note markers other than numbers, letters, or Roman numerals (asterisk, dagger, etc.) will be replaced with numbers.",
    "slug": "d2d_strip_notes",
    "enabled": false,
    "conversions": [
      "docx2docx"
    ]
  },
  {
    "name": "Place Footnotes after Section Breaks in MS Word",
    "description": "If this setting is enabled, when the Digital Hub converts footnotes embedded in a Word document, it will place footnotes at the end of their respective section of the document instead of at the end of the file.",
    "slug": "d2d_strip_fn_by_sect",
    "enabled": false,
    "conversions": [
      "docx2docx"
    ]
  },
  {
    "name": "Place Endnotes after Section Breaks in MS Word",
    "description": "If this setting is enabled, when the Digital Hub converts endnotes embedded in a Word document, it will place endnotes at the end of their respective section of the document instead of at the end of the file.",
    "slug": "d2d_strip_en_by_sect",
    "enabled": false,
    "conversions": [
      "docx2docx"
    ]
  },
  {
    "name": "Use Embedded MS Word Notes",
    "description": "If this setting is enabled, when the Digital Hub produces MS Word output it will embed the footnotes and endnotes using Word's native note feature.",
    "slug": "embed_docx_notes",
    "enabled": true,
    "conversions": [
      "sam2docx",
      "scml2docx",
      "indd2docx"
    ]
  },
  {
    "name": "Renumber Footnotes by Chapter",
    "description": "If enabled, the Hub will renumber footnotes within each chapter.",
    "slug": "note_renumber",
    "enabled": false,
    "conversions": [
      "docx2epub3",
      "docx2scml",
      "indd2epub3",
      "indd2scml",
      "sam2epub3",
      "sam2scml",
      "scml2scml"
    ]
  },
  {
    "name": "Reletter Footnotes by Chapter",
    "description": "If enabled, the Hub will reletter footnotes within each chapter.",
    "slug": "note_reletter",
    "enabled": false,
    "conversions": [
      "docx2epub3",
      "docx2scml",
      "indd2epub3",
      "indd2scml",
      "sam2epub3",
      "sam2scml",
      "scml2scml"
    ]
  },
  {
    "name": "Retain MS Word Images",
    "description": "If this setting is enabled, when the Digital Hub converts an MS Word document to sam, it will replace any images in the Word document with the Scribe image query format and add the image to the project assets.",
    "slug": "use_docx_images",
    "enabled": false,
    "conversions": [
      "docx2epub3",
      "docx2idtt",
      "docx2scml",
      "docx2sam"
    ]
  },
  {
    "name": "Include Blank Style Sheet",
    "description": "If this setting is enabled, when the Digital Hub converts an ScML file to HTML, it will embed a blank style sheet listing every style used in the document in the head of the HTML.",
    "slug": "html_css",
    "enabled": false,
    "conversions": [
      "docx2html",
      "indd2html",
      "sam2html",
      "scml2html"
    ]
  },
  {
    "name": "Visible Page Markers",
    "description": "If this setting is enabled, when the Digital Hub converts an ScML file to ePub 3 or HTML, it will include the page number as live text where the page number is indicated. Not recommended for standard use.",
    "slug": "visible_page_markers",
    "enabled": false,
    "conversions": [
      "docx2html",
      "indd2html",
      "sam2html",
      "scml2html",
      "docx2epub3",
      "indd2epub3",
      "sam2epub3",
      "scml2epub3"
    ]
  },
  {
    "name": "Pop-Up Footnotes",
    "description": "If this setting is enabled, when the Digital Hub converts an ScML file to HTML, it will include Javascript embedded in the HTML that will make the footnotes interactive pop-up boxes. This is not available for ePub conversions.",
    "slug": "popup_footnotes",
    "enabled": false,
    "conversions": [
      "docx2html",
      "indd2html",
      "sam2html",
      "scml2html"
    ]
  },
  {
    "name": "Embed Index Terms at Page Anchors",
    "description": "If enabled, the Digital Hub will embed index terms found in sam as metadata at the page locations associated with them. This is optimized for indexes formatted according to Chicago Manual of Style conventions.",
    "slug": "embed_index_terms",
    "enabled": false,
    "conversions": [
      "docx2epub3",
      "docx2scml",
      "indd2epub3",
      "indd2scml",
      "sam2epub3",
      "sam2scml"
    ]
  },
  {
    "name": "Draw Baseline Grid",
    "description": "The Hub will draw a baseline grid in the PDF to help when designing and reviewing templates. This should be turned off when generating the final PDF.",
    "slug": "draw_grid",
    "enabled": false,
    "conversions": [
      "scml2pdf"
    ]
  },
  {
    "name": "Add Chapter Structure Indicators",
    "description": "If enabled, the Hub will add chapter structure indicators around chapters that typically lack chapter titles, including the title, half title, copyright, and dedication pages. This works based on the applied ScML styles.",
    "slug": "add_structures",
    "enabled": false,
    "conversions": [
      "docx2docx"
    ]
  },
  {
    "name": "Preserve Word Comment Metadata",
    "description": "If enabled, the Hub will preserve Word comment metadata as XML, allowing comments to be embedded upon conversion back to Word. Otherwise, comments will be converted to simple text callouts.",
    "slug": "metadata_comments",
    "enabled": true,
    "conversions": [
      "docx2sam",
      "docx2scml"
    ]
  },
  {
    "name": "Place Hub Short Descriptions in ScML File",
    "description": "If enabled, the Hub will place short descriptions from the Hub record into the ScML file using the alt attribute. If the ScML file already has alt text associated with the image, the text in the ScML file will take precedence.",
    "slug": "place_image_alt_text",
    "enabled": true,
    "conversions": [
      "scml2scml"
    ]
  }
]